import axios from '../../helpers/axios'
import qs from 'querystring';
import { logError } from '../../services';
import { INeighborhoodRes, IVendorRes } from '../../models';

const base = `/api/production/lookup`;

export const getProductionNeighborhoods = async (
  filters: {
    territoryId?: number;
    page?: number;
    perPage?: number | string;
    sortBy?: string;
    sortDirection?: string;
    isActive?: boolean;
    hasActiveJobs?: boolean;
    hasActiveBuilds?: boolean;
    hasAvailableLots?: boolean;
    name?: string;
    code?: string | number;
    search?: string;
    hasSpecs?: boolean;
    hasPunchLists?: boolean;
    includeGeneralJob?: boolean;
    underContractBuildsOnly?: boolean;
  } = { sortBy: 'Name' }
): Promise<INeighborhoodRes> => {
  try {
    const { data } = await axios.get(`${base}/neighborhoods`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getProductionNeighborhoods failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getProductionVendors = async (filters?: {
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  isActive?: boolean;
  name?: string;
  subcontractorTypeIds?: string | number;
  vendorTypeIds?: number[];
  hasUsers?: boolean;
  hasPunchLists?: boolean;
  territoryId?: string | number;
  sageJobId?: number;
}): Promise<IVendorRes> => {
  try {
    const { data } = await axios.get(`${base}/vendors`, {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error) {
    logError(error, 'getProductionVendors failed');
    return Promise.reject(error);
  }
};
